const config = {
  appUrl: process.env.REACT_APP_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  loadApiUrl: process.env.REACT_APP_LOADS_API_URL,
  carrierApiUrl: process.env.REACT_APP_CARRIERS_API_URL,
  tripApiUrl: process.env.REACT_APP_TRIPS_API_URL,
  trackingApiUrl: process.env.REACT_APP_TRACKING_API_URL,
  appOrchidApiUrl: process.env.REACT_APP_ORCHID_API_URL,
  appOrchidUsername: process.env.REACT_APP_ORCHID_USERNAME,
  appOrchidPassword: process.env.REACT_APP_ORCHID_PASSWORD,
  appOrchidClientSecret: process.env.REACT_APP_ORCHID_CLIENT_SECRET,
  appOrchidClientId: process.env.REACT_APP_ORCHID_CLIENT_ID,
  cleverTapAcoountId: process.env.REACT_APP_CLEVER_TAP_ACCOUNT_ID,
  cleverTapRegion: process.env.REACT_APP_CLEVER_TAP_REGION,
  awsRegion: process.env.REACT_APP_AWS_REGION,
  awsBucketName: process.env.REACT_APP_AWS_BUCKET_NAME,
  awsAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY,
  awsSecretAccess: process.env.REACT_APP_AWS_SECRET_ACCESS,
  hereMapsApiKey: process.env.MAPS_API_KEY || "C8WhN14wZ-DWwXho2Oz8jph_yMwgXI-W586aUhQ29Jg",
};

export default config;
